import OpportunityCard from "./OpportunityCard"

export default function OpportunityCards ({
  opportunities,
  onOpportunityUpdate,
  shipModals
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '10px' }}>
      {opportunities.map(o => {
        return <OpportunityCard key={o.Id} opportunity={o} onOpportunityUpdate={onOpportunityUpdate} shipModals={shipModals} />
      })}
    </div>
  )
}